import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class CrmService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    // Lead ------------------------
    async leadCrmCreate(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmCreate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmList(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGet(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGet', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmFind(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmFind', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmUpdate(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmUpdateAgent(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmUpdateAgent', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmAddContact(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmAddContact', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmRevenueGet(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmRevenueGet', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    
    // Contact ------------------------
    async leadContactCrmCreate(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmCreate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadContactCrmList(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadContactCrmGet(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmGet', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadContactCrmFind(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmFind', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadContactCrmUpdate(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadContactCrmUpdateAgent(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmUpdateAgent', data, pos, this.changeAlert, null, null);
        
        return response?.data;
    }
    async leadContactCrmAddLead(data) {
        const pos = getPosition();
        const response = await API.service('leadContactCrmAddLead', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    // Taks --------------------------
    async taskCrmCreate(data) {
        const pos = getPosition();
        const response = await API.service('taskCrmCreate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async taskCrmList(data) {
        const pos = getPosition();
        const response = await API.service('taskCrmList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async taskCrmCommentAdd(data) {
        const pos = getPosition();
        const response = await API.service('taskCrmCommentAdd', data, pos, this.changeAlert, null, null);
        
        return response?.data;
    }
    async taskCrmUpdate(data) {
        const pos = getPosition();
        const response = await API.service('taskCrmUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async taskCrmDelete(data) {
        const pos = getPosition();
        const response = await API.service('taskCrmDelete', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    async panelCrmList(data) {
        const pos = getPosition();
        const response = await API.service('panelCrmList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    // Commissions --------------------------
    async commissionCrmCreate(data) {
        const pos = getPosition();
        const response = await API.service('commissionCrmCreate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async commissionCrmList(data) {
        const pos = getPosition();
        const response = await API.service('commissionCrmList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async commissionCrmGet(data) {
        const pos = getPosition();
        const response = await API.service('commissionCrmGet', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async commissionCrmFind(data) {
        const pos = getPosition();
        const response = await API.service('commissionCrmFind', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async commissionCrmUpdate(data) {
        const pos = getPosition();
        const response = await API.service('commissionCrmUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    // Sellers ----------------------------
    async sellerCrmCreate(data) {
        const pos = getPosition();
        const response = await API.service('sellerCrmCreate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async sellerCrmList(data) {
        const pos = getPosition();
        const response = await API.service('sellerCrmList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async sellerCrmGet(data) {
        const pos = getPosition();
        const response = await API.service('sellerCrmGet', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async sellerCrmFind(data) {
        const pos = getPosition();
        const response = await API.service('sellerCrmFind', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async sellerCrmUpdate(data) {
        const pos = getPosition();
        const response = await API.service('sellerCrmUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }

    // Lead GROUPS ----------------------
    async leadCrmGroupCreate(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupCreate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGroupList(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupList', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGroupGet(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupGet', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGroupFind(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupFind', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGroupUpdate(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupUpdate', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGroupAdd(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupAdd', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
    async leadCrmGroupDelete(data) {
        const pos = getPosition();
        const response = await API.service('leadCrmGroupDelete', data, pos, this.changeAlert, null, null);

        return response?.data;
    }
}